import {
  animate,
  query,
  stagger,
  style,
  transition,
  trigger
} from '@angular/animations'
import { DatePipe, formatDate } from '@angular/common'
import { Component, Inject, OnDestroy } from '@angular/core'
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Papa } from 'ngx-papaparse'
import { ToastrService } from 'ngx-toastr'
import { takeWhile } from 'rxjs/operators'
import { customerService } from 'src/app/services/customer/customer.service'
// import { ComapnyTableHeadings } from './modal/company'
// import { FarmerTableHeadings } from './modal/farmer'
// import { IndividualTraderTableHeadings } from './modal/IndividualTrader'
import { NgxUiLoaderService } from 'ngx-ui-loader'

@Component({
  selector: 'app-uploaderrorreport',
  templateUrl: './uploaderrorreport.component.html',
  styleUrls: ['./uploaderrorreport.component.css'],
  providers: [DatePipe],
  animations: [
    trigger('listAnimation', [
      transition('* => *', [
        query(
          ':enter',
          [
            style({ opacity: 0 }),
            stagger(100, [animate('0.4s', style({ opacity: 1 }))])
          ],
          { optional: true }
        )
      ])
    ])
  ]
})
export class UploaderrorreportComponent {

  isAlive: boolean = true
  convertedCSVData: any
  uploadErrorsForm: FormGroup
  responseOfUploadCSV: any
  subbmitted: boolean = false;
  // disableUploadButton: boolean
  errreMessages: any
  showLoaderMessage: boolean = false
  disabled: boolean
  // hideUploadeData: boolean = false
  // fileUploadData: boolean = false
  // customerType: any
  // Tableheading: { key: string; value: string }[]
  // convertedCSVDataForFarmer: any
  // convertedCSVDataForComapny: any
  // Details: any = []
  // postObj: any = []
  // excelData: any = []
  // selectDara: any = []
  // getResponce: any
  // selectFaileList: any
  // insertDate: any
  fileUploadErrorMsg: boolean = false
  fileUploadMsg: boolean = false
  constructor(
    public dialogRef: MatDialogRef<UploaderrorreportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private papa: Papa,
    private httpservice: customerService,
    private fb: UntypedFormBuilder,
    private tostr: ToastrService,
    private datePipe: DatePipe,
    private _loader: NgxUiLoaderService
  ) {
    this.uploadErrorsForm = fb.group({
      date: ['', [Validators.required]],
      // csv: ['', [Validators.required]],
      // customerType: ['', [Validators.required]]
    })
  }

  get f() {
    return this.uploadErrorsForm.controls
  }

  test = [];

  downloadReport() {
    this.subbmitted = true;
    if (this.uploadErrorsForm.valid) {
      this._loader.start();
      let date = (this.uploadErrorsForm.get('date').value);
      date = this.datePipe.transform(date, 'yyyy-MM-dd');
      this.httpservice.getCustomerUploadErrorReport(date).subscribe(
        res => {
          let blob: Blob = res.body as Blob;
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a')
          a.download = 'Customer Data Upload Error Report'
          a.href = url
          a.click();
          this._loader.stop();
          this.dialogRef.close('');
        }, err => {
          this._loader.stop();
          this.tostr.error(err);
          this.dialogRef.close('');
        }
      )
    }
  }


  ngOnDestroy(): void {
    this.isAlive = false
  }
}
